import React from 'react';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';

import { DialogUI } from '../../Interface';

const JmEasyReasonDialog = ({ open, handleClose, data, handleStopOperation, handleInterruptOperation, mode }) => {
  const handleClick = (code) => {
    if (mode === 'downtime') {
      handleStopOperation(null, code);
    } else {
      handleClose();
      handleInterruptOperation(code);
    }
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Megszakítás Ok kiválasztása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1300px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 0.5,
        },
      }}
    >
      <Box pb={2}>
        <IconButton size="small" onClick={handleClose}>
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{
              mt: 2,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              bgcolor: '#86a8c5',
              color: 'white',
            }}
          >
            <KeyboardBackspaceIcon
              sx={{
                fontSize: {
                  xs: '1.5rem',
                  sm: '2rem',
                },
              }}
            />

            <Typography
              component="span"
              sx={{
                fontSize: {
                  xs: '1.125rem',
                  sm: '1.5rem',
                },
                fontWeight: 500,
              }}
            >
              Vissza
            </Typography>
          </Stack>
        </IconButton>
      </Box>

      <Grid container justifyContent="center">
        {data.length > 0 &&
          data.map((item) => (
            <Grid
              item
              xs={6}
              sm="auto"
              p={{
                xs: 0.5,
                sm: 1,
              }}
              key={item.code}
            >
              <Box
                onClick={() => handleClick(item.code)}
                sx={{
                  width: {
                    xs: '100%',
                    sm: 220,
                  },
                  height: {
                    xs: 120,
                    sm: 200,
                  },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  px: 1,
                  borderRadius: 2,
                  bgcolor: '#6f9ad833',
                  color: '#014AB1',
                  border: '2px solid #014AB1',
                  textAlign: 'center',
                  cursor: 'pointer',
                  userSelect: 'none',
                  transition: 'background-color 0.2s ease',

                  '&:hover': {
                    bgcolor: '#6f9ad880',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: '1.4rem',
                      sm: '1.8rem',
                    },
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </Typography>
              </Box>
            </Grid>
          ))}
      </Grid>
    </DialogUI>
  );
};

export default JmEasyReasonDialog;
